const Input = ({ text, value, name, className, id, onChange, placeholder, min, max }) => {
    return (
        <>
            <label htmlFor={name} hidden>{name}</label>
            <input
                type={text}
                value={value}
                name={name}
                className={className}
                id={id} onChange={onChange}
                placeholder={placeholder}
                required={true}
                min={min}
                max={max}
            ></input>

        </>


    );
}
export default Input;